export enum TicketStatus {
	Active = 'Active',
	Pending = 'Pending',
	Closed = 'Closed',
	Spam = 'Spam',
	Archive = 'Archive',
	/** Parked until `snoozedUntil`, then back to Active. Set through the snooze endpoint only. */
	Snoozed = 'Snoozed',
}

export enum TicketPriority {
	Low = 'Low',
	Normal = 'Normal',
	High = 'High',
	Urgent = 'Urgent',
}

export enum TicketSource {
	Inbound = 'Inbound',
	Manual = 'Manual',
	Migrated = 'Migrated',
	Outbound = 'Outbound',
}

export enum Channel {
	Email = 'Email',
	Chat = 'Chat',
	Phone = 'Phone',
}

export enum ThreadType {
	CustomerMessage = 'CustomerMessage',
	AgentReply = 'AgentReply',
	Note = 'Note',
	AiDraft = 'AiDraft',
	Forward = 'Forward',
	AutoAcknowledgement = 'AutoAcknowledgement',
}

/**
 * Structured ticket activity events. These replace the former `ThreadType.System`
 * pseudo-threads: the API now records audit-style activity in `support.ticketEvents`
 * and exposes them via `GET support/tickets/{id}/events`.
 */
export enum SupportEventType {
	Assigned = 'Assigned',
	Unassigned = 'Unassigned',
	StatusChanged = 'StatusChanged',
	PriorityChanged = 'PriorityChanged',
	CategoryChanged = 'CategoryChanged',
	CustomerChanged = 'CustomerChanged',
	TicketLinked = 'TicketLinked',
	TicketUnlinked = 'TicketUnlinked',
	Merged = 'Merged',
	GitHubIssueLinked = 'GitHubIssueLinked',
	GitHubIssueUnlinked = 'GitHubIssueUnlinked',
	GitHubIssueCreated = 'GitHubIssueCreated',
	GitHubIssueSynced = 'GitHubIssueSynced',
	GitHubTriageResultReceived = 'GitHubTriageResultReceived',
	GitHubDraftGenerated = 'GitHubDraftGenerated',
	GitHubEscalationRequested = 'GitHubEscalationRequested',
	GitHubEngineeringIssueLinked = 'GitHubEngineeringIssueLinked',
	Forwarded = 'Forwarded',
	Rated = 'Rated',
	AccountChanged = 'AccountChanged',
	MailboxChanged = 'MailboxChanged',
	Snoozed = 'Snoozed',
	SnoozeEnded = 'SnoozeEnded',
	NoteDeleted = 'NoteDeleted',
}

export enum DeliveryStatus {
	Delivered = 'Delivered',
	Bounced = 'Bounced',
	Dropped = 'Dropped',
}

export enum ThreadStatus {
	Draft = 'Draft',
	Sent = 'Sent',
	Received = 'Received',
	Failed = 'Failed',
	Accepted = 'Accepted',
	Rejected = 'Rejected',
}

export enum AssignmentMethod {
	Balanced = 'Balanced',
	RoundRobin = 'RoundRobin',
}

export enum AgentRole {
	Support = 'Support',
	Admin = 'Admin',
}
